import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const sectionCard: ThemeApp['appComponents']['sectionCard'] = {
  boxShadow: themeUi.core.shadow.shadow4
};
